import { PropTypes } from "prop-types"
import classNames from "classnames"

import Button from "../Button"

export function ButtonModal(props) {
  const {
    ariaDescribedBy,
    ariaDescription,
    action,
    label,
    className,
    onClick,
    ...otherProps
  } = props

  const handleClick = () => {
    onClick()

    if (action) {
      action()
    }
  }

  return (
    <div className={classNames("oj-button-modal", className)}>
      {ariaDescribedBy && (
        <span className="button-description" id={ariaDescribedBy}>
          {ariaDescription}
        </span>
      )}
      <Button
        className="button-modal"
        ariaDescribedBy={ariaDescribedBy}
        {...otherProps}
        onClick={handleClick}
      >
        {label}
      </Button>
    </div>
  )
}

ButtonModal.propTypes = {
  ariaDescribedBy: PropTypes.string,
  ariaDescription: PropTypes.string,
  action: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.node,
  onClick: PropTypes.func
}

export default ButtonModal
